import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createStaticVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/figma.vue
var o = {
	name: "DtIconFigma",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--figma"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Figma",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24"
	}, [...t[0] || (t[0] = [r("<path d=\"M12.333 12a3.666 3.666 0 1 1 7.333 0 3.666 3.666 0 0 1-7.333 0Z\" fill=\"#1ABCFE\"></path><path d=\"M5 19.333a3.667 3.667 0 0 1 3.667-3.666h3.666v3.666a3.667 3.667 0 1 1-7.333 0Z\" fill=\"#0ACF83\"></path><path d=\"M12.333 1v7.333H16A3.667 3.667 0 0 0 16 1h-3.667Z\" fill=\"#FF7262\"></path><path d=\"M5 4.667a3.667 3.667 0 0 0 3.667 3.666h3.666V1H8.667A3.667 3.667 0 0 0 5 4.667Z\" fill=\"#F24E1E\"></path><path d=\"M5 12a3.666 3.666 0 0 0 3.667 3.667h3.666V8.333H8.667A3.667 3.667 0 0 0 5 12Z\" fill=\"#A259FF\"></path>", 5)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=figma.js.map